// import React, { useEffect, useRef, useState } from "react";

// const TimePicker24 = ({
//   value = "",
//   onChange,
//   disabled = false,
// }) => {
//   const pickerRef = useRef(null);

//   const [open, setOpen] = useState(false);

//   const [hour, setHour] = useState("00");
//   const [minute, setMinute] = useState("00");
//   const [second, setSecond] = useState("00");

//   const hours = Array.from(
//     { length: 24 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   const minutes = Array.from(
//     { length: 60 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   const seconds = Array.from(
//     { length: 60 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   // Load existing time
//   useEffect(() => {
//     if (value) {
//       const parts = value.split(":");

//       setHour(parts[0] || "00");
//       setMinute(parts[1] || "00");
//       setSecond(parts[2] || "00");
//     }
//   }, [value]);

//   // Close picker when clicked outside
//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (
//         pickerRef.current &&
//         !pickerRef.current.contains(event.target)
//       ) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener(
//       "mousedown",
//       handleOutsideClick
//     );

//     return () => {
//       document.removeEventListener(
//         "mousedown",
//         handleOutsideClick
//       );
//     };
//   }, []);

//   // Manual typing
//   const handleTextChange = (e) => {
//     const rawValue = e.target.value;

//     const numbers = rawValue
//       .replace(/\D/g, "")
//       .slice(0, 6);

//     let formatted = numbers;

//     if (numbers.length > 2) {
//       formatted =
//         numbers.slice(0, 2) +
//         ":" +
//         numbers.slice(2);
//     }

//     if (numbers.length > 4) {
//       formatted =
//         numbers.slice(0, 2) +
//         ":" +
//         numbers.slice(2, 4) +
//         ":" +
//         numbers.slice(4, 6);
//     }

//     onChange(formatted);
//   };

//   const openPicker = () => {
//     if (value) {
//       const parts = value.split(":");

//       setHour(parts[0] || "00");
//       setMinute(parts[1] || "00");
//       setSecond(parts[2] || "00");
//     }

//     setOpen(true);
//   };

//   const applyTime = () => {
//     const selectedTime =
//       `${hour}:${minute}:${second}`;

//     onChange(selectedTime);
//     setOpen(false);
//   };

//   return (
//     <div
//       ref={pickerRef}
//       style={{
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       {/* Main input */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           width: "100%",
//           border: "1px solid #ced4da",
//           borderRadius: "20px",
//           backgroundColor: disabled
//             ? "#e9ecef"
//             : "#ffffff",
//           overflow: "hidden",
//         }}
//       >
//         <input
//           type="text"
//           inputMode="numeric"
//           placeholder="HH:MM:SS"
//           maxLength={8}
//           disabled={disabled}
//           value={value || ""}
//           onChange={handleTextChange}
//           style={{
//             flex: 1,
//             height: "36px",
//             border: "none",
//             outline: "none",
//             paddingLeft: "18px",
//             backgroundColor: "transparent",
//             fontSize: "16px",
//           }}
//         />

//         <button
//           type="button"
//           disabled={disabled}
//           className="btn fa fa-clock-o"
//           style={{
//             color: "black",
//             width: "40px",
//             height: "36px",
//             padding: 0,
//             border: "none",
//             backgroundColor: "transparent",
//           }}
//           onClick={openPicker}
//         ></button>
//       </div>

//       {/* HH MM SS Picker */}
//       {open && !disabled && (
//         <div
//           style={{
//             position: "absolute",
//             right: 0,
//             top: "42px",
//             zIndex: 99999,
//             backgroundColor: "white",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             padding: "12px",
//             boxShadow:
//               "0 5px 18px rgba(0,0,0,0.25)",
//             minWidth: "260px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "end",
//               justifyContent: "center",
//               gap: "8px",
//             }}
//           >
//             {/* Hour */}
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "11px",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 HH
//               </label>

//               <select
//                 value={hour}
//                 onChange={(e) =>
//                   setHour(e.target.value)
//                 }
//                 className="form-control"
//               >
//                 {hours.map((item) => (
//                   <option
//                     key={item}
//                     value={item}
//                   >
//                     {item}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <strong style={{ paddingBottom: "8px" }}>
//               :
//             </strong>

//             {/* Minute */}
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "11px",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 MM
//               </label>

//               <select
//                 value={minute}
//                 onChange={(e) =>
//                   setMinute(e.target.value)
//                 }
//                 className="form-control"
//               >
//                 {minutes.map((item) => (
//                   <option
//                     key={item}
//                     value={item}
//                   >
//                     {item}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <strong style={{ paddingBottom: "8px" }}>
//               :
//             </strong>

//             {/* Seconds */}
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "11px",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//               >
//                 SS
//               </label>

//               <select
//                 value={second}
//                 onChange={(e) =>
//                   setSecond(e.target.value)
//                 }
//                 className="form-control"
//               >
//                 {seconds.map((item) => (
//                   <option
//                     key={item}
//                     value={item}
//                   >
//                     {item}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <div
//             style={{
//               marginTop: "12px",
//               textAlign: "center",
//             }}
//           >
//             <button
//               type="button"
//               className="btn btn-primary btn-sm"
//               onClick={applyTime}
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TimePicker24;

// import React, { useEffect, useRef, useState } from "react";
// import { createPortal } from "react-dom";

// // const modalRef = useRef(null);
// const TimePicker24 = ({
//   value = "",
//   onChange,
//   disabled = false,
// }) => {
//   const pickerRef = useRef(null);

//   const [open, setOpen] = useState(false);

//   const [hour, setHour] = useState("00");
//   const [minute, setMinute] = useState("00");
//   const [second, setSecond] = useState("00");

//   const [manualTime, setManualTime] = useState("");

//   const hours = Array.from(
//     { length: 24 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   const minutes = Array.from(
//     { length: 60 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   const seconds = Array.from(
//     { length: 60 },
//     (_, i) => String(i).padStart(2, "0")
//   );

//   // --------------------------------------------------
//   // Format typed numbers into HH:MM:SS
//   // Example:
//   // 163000 -> 16:30:00
//   // --------------------------------------------------
//   const formatTimeInput = (input) => {
//     const numbers = input
//       .replace(/\D/g, "")
//       .slice(0, 6);

//     if (numbers.length <= 2) {
//       return numbers;
//     }

//     if (numbers.length <= 4) {
//       return (
//         numbers.slice(0, 2) +
//         ":" +
//         numbers.slice(2)
//       );
//     }

//     return (
//       numbers.slice(0, 2) +
//       ":" +
//       numbers.slice(2, 4) +
//       ":" +
//       numbers.slice(4, 6)
//     );
//   };

//   // --------------------------------------------------
//   // Validate complete HH:MM:SS
//   // --------------------------------------------------
//   const isValidTime = (time) => {
//     const match = time.match(
//       /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/
//     );

//     return !!match;
//   };

//   // --------------------------------------------------
//   // Load existing value
//   // --------------------------------------------------
//   useEffect(() => {
//     if (value) {
//       const parts = value.split(":");

//       const h = parts[0] || "00";
//       const m = parts[1] || "00";
//       const s = parts[2] || "00";

//       setHour(h);
//       setMinute(m);
//       setSecond(s);
//       setManualTime(`${h}:${m}:${s}`);
//     }
//   }, [value]);

//   // --------------------------------------------------
//   // Close when clicked outside
//   // --------------------------------------------------
//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (
//         pickerRef.current &&
//         !pickerRef.current.contains(event.target)
//       ) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener(
//       "pointerdown",
//       handleOutsideClick
//     );

//     return () => {
//       document.removeEventListener(
//         "pointerdown",
//         handleOutsideClick
//       );
//     };
//   }, []);

//   // --------------------------------------------------
//   // Main field typing
//   // --------------------------------------------------
//   const handleMainInputChange = (e) => {
//     const formatted = formatTimeInput(
//       e.target.value
//     );

//     onChange(formatted);
//   };

//   // --------------------------------------------------
//   // Manual field INSIDE popup
//   // --------------------------------------------------
//   const handleManualChange = (e) => {
//     const formatted = formatTimeInput(
//       e.target.value
//     );

//     setManualTime(formatted);

//     // Synchronize picker when full time entered
//     if (isValidTime(formatted)) {
//       const [h, m, s] = formatted.split(":");

//       setHour(h);
//       setMinute(m);
//       setSecond(s);
//     }
//   };

//   // --------------------------------------------------
//   // Picker changed
//   // --------------------------------------------------
//   const updatePickerTime = (
//     newHour,
//     newMinute,
//     newSecond
//   ) => {
//     const h = newHour ?? hour;
//     const m = newMinute ?? minute;
//     const s = newSecond ?? second;

//     setHour(h);
//     setMinute(m);
//     setSecond(s);

//     setManualTime(`${h}:${m}:${s}`);
//   };

//   // --------------------------------------------------
//   // Open picker
//   // --------------------------------------------------
//   const openPicker = () => {
//     let h = "00";
//     let m = "00";
//     let s = "00";

//     if (value && isValidTime(value)) {
//       const parts = value.split(":");

//       h = parts[0];
//       m = parts[1];
//       s = parts[2];
//     }

//     setHour(h);
//     setMinute(m);
//     setSecond(s);
//     setManualTime(`${h}:${m}:${s}`);

//     setOpen(true);
//   };

//   // --------------------------------------------------
//   // Apply
//   // --------------------------------------------------
//   const applyTime = () => {
//     const selectedTime =
//       `${hour}:${minute}:${second}`;

//     onChange(selectedTime);

//     setOpen(false);
//   };

//   // --------------------------------------------------
//   // Quick Time
//   // --------------------------------------------------
//   const setQuickTime = (time) => {
//     const [h, m, s] = time.split(":");

//     setHour(h);
//     setMinute(m);
//     setSecond(s);

//     setManualTime(time);
//   };

//   return (
//     <div
//       ref={pickerRef}
//       style={{
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       {/* MAIN INPUT */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           width: "100%",
//           border: "1px solid #ced4da",
//           borderRadius: "20px",
//           backgroundColor: disabled
//             ? "#e9ecef"
//             : "#ffffff",
//           overflow: "hidden",
//         }}
//       >
//         <input
//           type="text"
//           inputMode="numeric"
//           placeholder="HH:MM:SS"
//           maxLength={8}
//           disabled={disabled}
//           value={value || ""}
//           onChange={handleMainInputChange}
//           style={{
//             flex: 1,
//             minWidth: 0,
//             height: "38px",
//             border: "none",
//             outline: "none",
//             paddingLeft: "18px",
//             backgroundColor: "transparent",
//             fontSize: "16px",
//           }}
//         />

//         <button
//           type="button"
//           disabled={disabled}
//           className="btn fa fa-clock-o"
//           onClick={openPicker}
//           style={{
//             color: "black",
//             width: "45px",
//             height: "38px",
//             padding: 0,
//             border: "none",
//             backgroundColor: "transparent",
//           }}
//           aria-label="Open time picker"
//         />
//       </div>

//     {open &&
//       !disabled &&
//       createPortal(
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,

//             zIndex: 999999,

//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",

//             padding: "15px",

//             backgroundColor: "rgba(0,0,0,0.35)",
//           }}
//           onClick={() => setOpen(false)}
//         >
//           <div
//             ref={modalRef}
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               width: "100%",
//               maxWidth: "340px",

//               backgroundColor: "#ffffff",

//               borderRadius: "14px",
//               padding: "16px",

//               boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
//             }}
//           >
//             <div
//               style={{
//                 fontWeight: "bold",
//                 fontSize: "18px",
//                 marginBottom: "12px",
//               }}
//             >
//               Set Time
//             </div>

//             <label
//               style={{
//                 display: "block",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 marginBottom: "5px",
//               }}
//             >
//               Enter Time
//             </label>

//             <input
//               type="text"
//               inputMode="numeric"
//               placeholder="HH:MM:SS"
//               maxLength={8}
//               value={manualTime}
//               onChange={handleManualChange}
//               className="form-control"
//               style={{
//                 textAlign: "center",
//                 fontSize: "20px",
//                 fontWeight: "bold",
//                 marginBottom: "15px",
//               }}
//             />

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "end",
//                 justifyContent: "center",
//                 gap: "5px",
//               }}
//             >
//               <div style={{ flex: 1 }}>
//                 <label
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     fontSize: "11px",
//                   }}
//                 >
//                   HH
//                 </label>

//                 <select
//                   value={hour}
//                   onChange={(e) =>
//                     updatePickerTime(
//                       e.target.value,
//                       null,
//                       null
//                     )
//                   }
//                   className="form-control"
//                 >
//                   {hours.map((item) => (
//                     <option key={item} value={item}>
//                       {item}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <strong style={{ paddingBottom: "8px" }}>
//                 :
//               </strong>

//               <div style={{ flex: 1 }}>
//                 <label
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     fontSize: "11px",
//                   }}
//                 >
//                   MM
//                 </label>

//                 <select
//                   value={minute}
//                   onChange={(e) =>
//                     updatePickerTime(
//                       null,
//                       e.target.value,
//                       null
//                     )
//                   }
//                   className="form-control"
//                 >
//                   {minutes.map((item) => (
//                     <option key={item} value={item}>
//                       {item}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <strong style={{ paddingBottom: "8px" }}>
//                 :
//               </strong>

//               <div style={{ flex: 1 }}>
//                 <label
//                   style={{
//                     display: "block",
//                     textAlign: "center",
//                     fontSize: "11px",
//                   }}
//                 >
//                   SS
//                 </label>

//                 <select
//                   value={second}
//                   onChange={(e) =>
//                     updatePickerTime(
//                       null,
//                       null,
//                       e.target.value
//                     )
//                   }
//                   className="form-control"
//                 >
//                   {seconds.map((item) => (
//                     <option key={item} value={item}>
//                       {item}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 flexWrap: "wrap",
//                 gap: "6px",
//                 marginTop: "15px",
//               }}
//             >
//               <button
//                 type="button"
//                 className="btn btn-sm btn-secondary"
//                 onClick={() => setQuickTime("00:00:00")}
//               >
//                 00:00:00
//               </button>

//               <button
//                 type="button"
//                 className="btn btn-sm btn-secondary"
//                 onClick={() => setQuickTime("08:00:00")}
//               >
//                 08:00:00
//               </button>

//               <button
//                 type="button"
//                 className="btn btn-sm btn-secondary"
//                 onClick={() => setQuickTime("23:59:59")}
//               >
//                 23:59:59
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 gap: "10px",
//                 marginTop: "18px",
//               }}
//             >
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 style={{ flex: 1 }}
//                 onClick={() => setOpen(false)}
//               >
//                 Cancel
//               </button>

//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 style={{ flex: 1 }}
//                 onClick={applyTime}
//               >
//                 Apply
//               </button>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}


//     </div>
//   );
// };

// export default TimePicker24;

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const TimePicker24 = ({
  value = "",
  onChange,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);

  const [hour, setHour] = useState("00");
  const [minute, setMinute] = useState("00");
  const [second, setSecond] = useState("00");
  const [manualTime, setManualTime] = useState("");
  const [manualError, setManualError] = useState("");

  const hours = Array.from(
    { length: 24 },
    (_, i) => String(i).padStart(2, "0")
  );

  const minutes = Array.from(
    { length: 60 },
    (_, i) => String(i).padStart(2, "0")
  );

  const seconds = Array.from(
    { length: 60 },
    (_, i) => String(i).padStart(2, "0")
  );

  const formatTimeInput = (input) => {
    const numbers = input
      .replace(/\D/g, "")
      .slice(0, 6);

    if (numbers.length <= 2) {
      return numbers;
    }

    if (numbers.length <= 4) {
      return `${numbers.slice(0, 2)}:${numbers.slice(2)}`;
    }

    return `${numbers.slice(0, 2)}:${numbers.slice(2, 4)}:${numbers.slice(4, 6)}`;
  };

  const isValidTime = (time) =>
    /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(time);

  useEffect(() => {
    if (value && isValidTime(value)) {
      const [h, m, s] = value.split(":");

      setHour(h);
      setMinute(m);
      setSecond(s);
      setManualTime(value);
      setManualError("");
    } else if (!value) {
      setHour("00");
      setMinute("00");
      setSecond("00");
      setManualTime("");
      setManualError("");
    }
  }, [value]);

  const handleMainInputChange = (e) => {
    const formatted = formatTimeInput(e.target.value);
    onChange(formatted);
  };

  const openPicker = () => {
    if (value && isValidTime(value)) {
      const [h, m, s] = value.split(":");

      setHour(h);
      setMinute(m);
      setSecond(s);
      setManualTime(value);
    } else {
      setHour("00");
      setMinute("00");
      setSecond("00");
      setManualTime("00:00:00");
    }

    setManualError("");
    setOpen(true);
  };

  const handleManualChange = (e) => {
    const formatted = formatTimeInput(e.target.value);

    setManualTime(formatted);
    setManualError("");

    if (isValidTime(formatted)) {
      const [h, m, s] = formatted.split(":");

      setHour(h);
      setMinute(m);
      setSecond(s);
    }
  };

  const updatePickerTime = (
    newHour = hour,
    newMinute = minute,
    newSecond = second
  ) => {
    const selectedHour = newHour === null ? hour : newHour;
    const selectedMinute = newMinute === null ? minute : newMinute;
    const selectedSecond = newSecond === null ? second : newSecond;

    setHour(selectedHour);
    setMinute(selectedMinute);
    setSecond(selectedSecond);

    setManualTime(
      `${selectedHour}:${selectedMinute}:${selectedSecond}`
    );

    setManualError("");
  };

  const setQuickTime = (time) => {
    const [h, m, s] = time.split(":");

    setHour(h);
    setMinute(m);
    setSecond(s);
    setManualTime(time);
    setManualError("");
  };

  const applyTime = () => {
    if (!isValidTime(manualTime)) {
      setManualError(
        "Enter a valid time between 00:00:00 and 23:59:59."
      );
      return;
    }

    onChange(manualTime);
    setOpen(false);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          border: "1px solid #ced4da",
          borderRadius: "20px",
          backgroundColor: disabled ? "#e9ecef" : "#ffffff",
          overflow: "hidden",
        }}
      >
        <input
          type="text"
          inputMode="numeric"
          placeholder="HH:MM:SS"
          maxLength={8}
          disabled={disabled}
          value={value || ""}
          onChange={handleMainInputChange}
          style={{
            flex: 1,
            minWidth: 0,
            height: "38px",
            border: "none",
            outline: "none",
            paddingLeft: "18px",
            backgroundColor: "transparent",
            fontSize: "16px",
          }}
        />

        <button
          type="button"
          disabled={disabled}
          className="btn fa fa-clock-o"
          onClick={openPicker}
          style={{
            color: "black",
            width: "45px",
            height: "38px",
            padding: 0,
            border: "none",
            backgroundColor: "transparent",
          }}
          aria-label="Open time picker"
        />
      </div>

      {open &&
        !disabled &&
        createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 999999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "15px",
              backgroundColor: "rgba(0, 0, 0, 0.40)",
            }}
            onMouseDown={() => setOpen(false)}
          >
            <div
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "340px",
                maxHeight: "90vh",
                overflowY: "auto",
                backgroundColor: "#ffffff",
                borderRadius: "14px",
                padding: "16px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginBottom: "12px",
                }}
              >
                Set Time
              </div>

              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                Enter Time
              </label>

              <input
                type="text"
                inputMode="numeric"
                placeholder="HH:MM:SS"
                maxLength={8}
                value={manualTime}
                onChange={handleManualChange}
                className="form-control"
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: manualError ? "4px" : "15px",
                }}
              />

              {manualError && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "11px",
                    marginBottom: "12px",
                    textAlign: "center",
                  }}
                >
                  {manualError}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  gap: "5px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    HH
                  </label>

                  <select
                    value={hour}
                    onChange={(e) =>
                      updatePickerTime(
                        e.target.value,
                        null,
                        null
                      )
                    }
                    className="form-control"
                  >
                    {hours.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <strong style={{ paddingBottom: "8px" }}>
                  :
                </strong>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    MM
                  </label>

                  <select
                    value={minute}
                    onChange={(e) =>
                      updatePickerTime(
                        null,
                        e.target.value,
                        null
                      )
                    }
                    className="form-control"
                  >
                    {minutes.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <strong style={{ paddingBottom: "8px" }}>
                  :
                </strong>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    SS
                  </label>

                  <select
                    value={second}
                    onChange={(e) =>
                      updatePickerTime(
                        null,
                        null,
                        e.target.value
                      )
                    }
                    className="form-control"
                  >
                    {seconds.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginTop: "15px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("00:00:00")}
                >
                  00:00:00
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("08:00:00")}
                >
                  08:00:00
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("18:00:00")}
                >
                  18:00:00
                </button>
              </div>
                            <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginTop: "15px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("20:00:00")}
                >
                  20:00:00
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("22:00:00")}
                >
                  22:00:00
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setQuickTime("23:59:59")}
                >
                  23:59:59
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "18px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ flex: 1 }}
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ flex: 1 }}
                  onClick={applyTime}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default TimePicker24;